import { Alert, Modal, Select } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useMoveExpenseToLedger } from "../../api/api";
import { useGetAllLedgers } from "../../api/api.get";
import { useGroupContext } from "../../providers/groups.provider";
import { IExpense2 } from "../../types/types";

export default function SaveAsLedgerExpenseDialog({
  open,
  onCancel,
  onOk,
  expense,
}: {
  expense?: IExpense2;
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
}) {
  const { defaultGroupId } = useGroupContext();
  const { data: ledgersData } = useGetAllLedgers(defaultGroupId);

  const { mutateAsync, error } = useMoveExpenseToLedger(
    defaultGroupId,
    expense?.id,
  );

  const optionsData = useMemo(() => {
    if (ledgersData) {
      return ledgersData.map((t) => {
        return { label: t.name, value: t.id };
      });
    }
  }, [ledgersData]);

  const [selectedLedger, setSelectedLedger] = useState<string | undefined>();

  useEffect(() => {
    if (ledgersData) {
      setSelectedLedger(ledgersData[0]?.id);
    }
  }, [ledgersData]);

  const handleSubmit = () => {
    mutateAsync({ ledgerId: selectedLedger! }).then(onOk);
  };

  return (
    <Modal
      title={"Change To Ledger Expense?"}
      closable={{ "aria-label": "Custom Close Button" }}
      open={open}
      onOk={handleSubmit}
      onCancel={onCancel}
    >
      <div className="flex flex-col justify-center items-center mb-10">
        {error && (
          <Alert type="error" title={"Unable to process. Please try again"} />
        )}
        <div className="flex mt-4 gap-5">
          <Select
            style={{ width: 300 }}
            placeholder="Select a ledger"
            onChange={(value) => setSelectedLedger(value)}
            options={optionsData}
            value={selectedLedger}
          />
        </div>
      </div>
    </Modal>
  );
}
